import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'spaq-button',
	template: `
		<button
			[disabled]="disabled"
			[primary]="primary"
			[attr.data-testid]="testId"
			kendoButton
			class="w-100 mt-4"
			(click)="click()"
			type="button"
		>
			<ng-content></ng-content>
		</button>
	`,
	styles: []
})
export class ButtonComponent {
	@Input() disabled = false;
	@Input() link: string;
	@Output() buttonClick = new EventEmitter();
	@Input() primary = false;
	@Input() testId: string;
	@Input() value: string;

	constructor(private router: Router) {}
	click() {
		if (this.buttonClick) {
			this.buttonClick.emit(this.value);
		}
		if (this.link) {
			this.router.navigate([this.link]);
		}
	}
}
